export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string) || "https://usfanslink.lol";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export const SUPPORTED_LANGS = ["en", "fr", "es", "pl"] as const;

export type Lang = (typeof SUPPORTED_LANGS)[number];

export const LANG_LABELS: Record<Lang, string> = {
  en: "English",
  fr: "Français",
  es: "Español",
  pl: "Polski",
};

export interface Category {
  key: string;
  url: string;
  image: string;
}

export const CATEGORIES: Category[] = [
  {
    key: "shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20crisp%20white%20low-top%20sneakers%20photographed%20on%20a%20soft%20sage%20green%20studio%20backdrop%2C%20gentle%20diffused%20natural%20light%20from%20the%20left%2C%20subtle%20soft%20shadow%20beneath%2C%20clean%20minimalist%20e-commerce%20catalog%20photography%2C%20crisp%20details%20on%20the%20leather%20texture%20and%20laces%2C%20plenty%20of%20negative%20space%2C%20fresh%20modern%20aesthetic&width=600&height=600&seq=cat-shoes-v2&orientation=square&nocache=true",
  },
  {
    key: "hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20heavyweight%20cream%20hoodie%20with%20visible%20drawstrings%20resting%20on%20a%20warm%20blush%20pink%20studio%20surface%2C%20soft%20natural%20window%20light%2C%20gentle%20shadow%2C%20minimalist%20e-commerce%20apparel%20photography%2C%20detailed%20fabric%20texture%2C%20clean%20composition%20with%20negative%20space%2C%20cozy%20inviting%20tone&width=600&height=600&seq=cat-hoodies-v2&orientation=square&nocache=true",
  },
  {
    key: "tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20neat%20stack%20of%20folded%20cotton%20t-shirts%20in%20muted%20earthy%20tones%20of%20olive%2C%20sand%20and%20terracotta%20on%20a%20warm%20beige%20studio%20backdrop%2C%20soft%20directional%20lighting%2C%20subtle%20shadows%2C%20minimalist%20clothing%20catalog%20photography%2C%20crisp%20fabric%20folds%2C%20clean%20airy%20composition&width=600&height=600&seq=cat-tshirts-v2&orientation=square&nocache=true",
  },
  {
    key: "jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20beige%20bomber%20jacket%20displayed%20on%20a%20wooden%20hanger%20against%20a%20soft%20terracotta%20wall%2C%20warm%20natural%20side%20lighting%2C%20gentle%20shadow%2C%20editorial%20fashion%20catalog%20photography%2C%20visible%20stitching%20and%20zipper%20detail%2C%20minimal%20and%20clean%20composition&width=600&height=600&seq=cat-jackets-v2&orientation=square&nocache=true",
  },
  {
    key: "pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20folded%20dark%20denim%20jeans%20and%20a%20beige%20chino%20pant%20arranged%20neatly%20on%20a%20pale%20olive%20green%20studio%20surface%2C%20soft%20diffused%20daylight%2C%20subtle%20shadow%2C%20minimalist%20fashion%20catalog%20photography%2C%20clear%20fabric%20texture%20and%20stitching%2C%20clean%20negative%20space&width=600&height=600&seq=cat-pants-v2&orientation=square&nocache=true",
  },
  {
    key: "headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20classic%20structured%20baseball%20cap%20in%20warm%20camel%20color%20on%20a%20soft%20peach%20studio%20backdrop%2C%20gentle%20natural%20lighting%2C%20soft%20shadow%2C%20minimalist%20e-commerce%20product%20photography%2C%20visible%20embroidery%20and%20brim%20curve%20detail%2C%20clean%20airy%20composition&width=600&height=600&seq=cat-headwear-v2&orientation=square&nocache=true",
  },
  {
    key: "sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20coordinated%20matching%20outfit%20set%20of%20a%20top%20and%20jogger%20pants%20laid%20flat%20on%20a%20warm%20cream%20linen%20background%2C%20soft%20morning%20light%2C%20gentle%20shadows%2C%20minimalist%20flat%20lay%20fashion%20photography%2C%20harmonious%20neutral%20color%20palette%2C%20clean%20balanced%20composition&width=600&height=600&seq=cat-sets-v2&orientation=square&nocache=true",
  },
  {
    key: "underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=Neatly%20folded%20soft%20cotton%20boxer%20briefs%20in%20charcoal%20and%20cream%20tones%20on%20a%20warm%20light%20gray%20studio%20surface%2C%20soft%20diffused%20lighting%2C%20subtle%20shadow%2C%20minimalist%20apparel%20catalog%20photography%2C%20crisp%20fabric%20texture%20and%20elastic%20waistband%20detail%2C%20clean%20tidy%20composition&width=600&height=600&seq=cat-underwear-v2&orientation=square&nocache=true",
  },
  {
    key: "jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20modern%20sports%20jersey%20in%20soft%20mint%20and%20white%20tones%20hanging%20on%20a%20wooden%20hanger%20against%20a%20clean%20neutral%20backdrop%2C%20bright%20soft%20studio%20lighting%2C%20gentle%20shadow%2C%20editorial%20sportswear%20photography%2C%20visible%20team-number%20print%20and%20fabric%20texture%2C%20minimal%20composition&width=600&height=600&seq=cat-jersey-v2&orientation=square&nocache=true",
  },
  {
    key: "accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20wristwatch%20with%20a%20leather%20strap%20and%20a%20few%20small%20accessories%20arranged%20in%20a%20tidy%20flat%20lay%20on%20a%20warm%20taupe%20studio%20surface%2C%20soft%20natural%20light%2C%20subtle%20shadows%2C%20minimalist%20e-commerce%20product%20photography%2C%20crisp%20details%20on%20dial%20and%20metal%2C%20clean%20composition&width=600&height=600&seq=cat-accessories-v2&orientation=square&nocache=true",
  },
  {
    key: "bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20rich%20caramel%20brown%20leather%20backpack%20standing%20upright%20on%20a%20soft%20warm%20cream%20studio%20backdrop%2C%20gentle%20directional%20lighting%2C%20soft%20shadow%2C%20minimalist%20e-commerce%20product%20photography%2C%20visible%20stitching%20and%20brass%20hardware%20detail%2C%20clean%20negative%20space&width=600&height=600&seq=cat-bags-v2&orientation=square&nocache=true",
  },
  {
    key: "belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=A%20rolled%20leather%20belt%20with%20a%20brushed%20metal%20buckle%20on%20a%20warm%20tan%20studio%20surface%2C%20soft%20natural%20side%20light%2C%20subtle%20shadow%2C%20minimalist%20fashion%20accessory%20photography%2C%20rich%20leather%20grain%20texture%2C%20clean%20elegant%20composition&width=600&height=600&seq=cat-belts-v2&orientation=square&nocache=true",
  },
  {
    key: "perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20amber%20glass%20perfume%20bottle%20on%20a%20soft%20rose%20blush%20studio%20backdrop%20with%20a%20delicate%20reflection%2C%20soft%20diffused%20lighting%2C%20gentle%20shadow%2C%20minimalist%20luxury%20fragrance%20photography%2C%20crisp%20label%20and%20glass%20detail%2C%20clean%20refined%20composition&width=600&height=600&seq=cat-perfumes-v2&orientation=square&nocache=true",
  },
  {
    key: "other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image:
      "https://readdy.ai/api/search-image?query=An%20assorted%20flat%20lay%20of%20everyday%20lifestyle%20items%20including%20a%20notebook%2C%20sunglasses%2C%20keychain%20and%20small%20pouch%20arranged%20on%20a%20soft%20sage%20green%20background%2C%20soft%20natural%20light%2C%20subtle%20shadows%2C%20minimalist%20editorial%20product%20photography%2C%20harmonious%20colors%2C%20clean%20composition&width=600&height=600&seq=cat-other-v2&orientation=square&nocache=true",
  },
];

export const HERO_IMAGE =
  "https://readdy.ai/api/search-image?query=A%20soft%20abstract%20modern%20background%20with%20layered%20translucent%20geometric%20shapes%20and%20subtle%20floating%20product%20silhouettes%20in%20warm%20sage%2C%20cream%2C%20terracotta%20and%20sand%20tones%2C%20airy%20and%20clean%2C%20gentle%20gradient%20with%20plenty%20of%20negative%20space%2C%20premium%20e-commerce%20aesthetic%2C%20soft%20diffused%20light%2C%20high%20resolution&width=1600&height=900&seq=hero-usfans-v2&orientation=landscape&nocache=true";